import React from 'react'
import Layout from '../components/Layout'
import Image from 'react-bootstrap/Image'
import { getPossibleProfileImage, getUserImage } from '../managers/ImageHelper'
import {connect} from "react-redux"
import GameplanCard from '../components/GameplanCard'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import UserAPI from '../api/UserAPI'
import LocalAPI from '../api/LocalAPI'
import ConstrainedFormGroup from '../components/ConstrainedFormGroup'
import ArticleSection from '../components/ArticleSection'
import Container from 'react-bootstrap/Container'
import MainUser from '../components/MainUser'
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import ModalManager from '../managers/ModalManager'
import SystemModal from '../components/SystemModal'
import { print } from '../managers/Logger'
import EventCell from '../components/EventCell'
import NoSSR from 'react-no-ssr'
import Router from 'next/router'
import UtilsManager from '../managers/UtilsManager'
import ErrorView from '../components/ErrorView';
import FileUploader from '../components/FileUploader'
import ErrorManager from '../managers/ErrorManager'
import MetricsManager from '../managers/MetricsManager'

class Profile extends React.Component { 

	constructor(props) { 
		super(props)
		this.state = { 
			public: this.props.promoter !== undefined,
			canEditProfile: false, 
			canEditPromoter: false, 
			username: '',
			email: '', 
			access: [],
			editingAccess: null,
			creatingAccess: false,
			system: ModalManager.shell(),
			showEditModal: false,
			organizerName: '',
			instagram: '',
			organizerBio: '', 
			uploadedUserImage: null
		}

		this.userApi = new UserAPI()
		this.userApi.setAuth(this.props.auth)
		this.modalManager = new ModalManager()
		this.errorManager = new ErrorManager()
		this.metricsManager = new MetricsManager();
	}

	static async getInitialProps(context) { 
		var key = context.query.key
		print(`key is ${key}`)
		if (key === undefined || key === null){ 
			print("no username, returning empty props")
			return {}
		}

		const utilsManager = new UtilsManager()
		const queryKey  = utilsManager.getIntegerFromUrl(key)
		
		if (queryKey !== null) { 
			key = queryKey
		}
		const userAPI = new UserAPI()
		const result = await userAPI.getPromoterPublicView(key)
		if (result === null || result.code === -1) { 
			return {error: true}
		}
		console.log(result)
		return {promoter: result}
	}

	componentDidMount() { 
		// TODO: Handle page loading with no user
		this.metricsManager.logEvent("page_view", {label: "profile"})
		window.scrollTo(0, 0)
		print(`Profile props are ${this.props}`)
		if (this.props.user !== null && this.props.user !== undefined) { 
			this.setState({username: this.props.user.username, email: this.props.user.email})
			this.getAdminAccess()
		}	

		const promoter = MainUser.getAdminAccess(this.props.user)
		if (promoter !== null) { 
			this.setState({organizerName: promoter.unique_name, instagram: promoter.instagram, organizerBio: promoter.about})
		}
		
	}

	async handlePromoterUpdate() { 
		this.modalManager.showLoading(this)
		const body = {
			unique_name: this.state.organizerName, 
			about: this.state.organizerBio,
			instagram: this.state.instagram
		}
		const promoter = MainUser.getAdminAccess(this.props.user)
		const response = await this.userApi.updatePromoter(promoter.id, body)
		if (response === null || response.code === -1) { 
			alert("Failed to update")
		} else { 
			window.location.reload(true)
		}
		
	}

	getProfileButton() { 
		if (this.state.canEditProfile === false) { 
			return <Button variant="primary" onClick={()=> this.setState({canEditProfile: true})}>Edit</Button>
		} else { 
			return (
				<div>
				<Button variant="primary" onClick={()=> this.handleProfileSubmit()}>Submit</Button>
				<Button variant="primary" onClick={()=> this.setState({canEditProfile: false, 
					username: this.props.user.username, email: this.props.user.email})}>Cancel</Button>
				</div>)
		}
	}

	getPromoterButton() { 	
		if (this.state.canEditPromoter === false) { 
			return <Button variant="primary" onClick={()=> this.setState({canEditPromoter: true})}>Edit</Button>
		} else { 
			return (
				<div>
				<Button variant="primary" onClick={()=> this.handlePromoterUpdate()}>Submit</Button>
				<Button variant="primary" onClick={()=> this.setState({canEditPromoter: false})}>Cancel</Button>
				</div>)
		}
	}

	onChange(index, value) { 
		if (index == 0){ 
			this.setState({username: value})
			return
		}

		if (index == 1) { 
			this.setState({email: value})
			return
		}

		if (index == 2) { 
			const access = this.state.editingAccess
			access.access_level = value
			print(value)
			this.setState({editingAccess: access})
		}

		if (index == 3) { 
			const access = this.state.editingAccess
			access.username = value
			this.setState({editingAccess: access})
		}

		if (index === 4) { 
			this.setState({organizerName:value})
		}

		if (index === 5) { 
			this.setState({instagram: value})
		}

		if (index == 6) { 
			this.setState({organizerBio: value})
		} 
	}

	async handleProfileSubmit() { 
		this.modalManager.showLoading(this)
		
		console.log(this.state.uploadedUserImage)
		if (this.state.uploadedUserImage !== null) { 
			const profileResult = await this.userApi.uploadProfilePicture(this.state.uploadedUserImage)
			if (profileResult === null || profileResult.code === -1) { 
				alert("Couldn't update profile picture")
			}
		}

		// If nothing has changed, do nothing.
		const updateBody = {}
		if (this.state.username == '' || this.state.email == '')  { 
			alert("You must have a valid username and email")
		}

		if (this.state.username != this.props.user.username)  { 
			updateBody.username = this.state.username
		} 

		if (this.state.email != this.props.user.email)  { 
			updateBody.email = this.state.email
		}

		// Nothing has changed.
		if (updateBody.email === undefined && updateBody.username == undefined) { 
			// Reload page.
			window.location.reload(true)
		}
	

		const result = await this.userApi.updateUser(this.props.user.id, updateBody) 
		print(result)


		if (result == null) { 
			alert("Something went wrong")
			return
		}
		
		if (!result || result.code == -1) { 
			// This won't work for serializer errosrs since they return based on the key of the field.
			const errMsg = this.errorManager.getErrorStringOrDefault(result, "Sorry, we failed to update your account");
			alert(errMsg)
			return
		}

		window.location.reload(true)
	}

	async logout() { 
		const localApi = new LocalAPI()
		const result = await localApi.logout()
		if (result !== null && result.code !== -1) { 
			window.location.href = "/"
		} else { 
			alert("Failed to update account")
		}
	}



	async getAdminAccess() { 
		const promoter = MainUser.getAdminAccess(this.props.user)
		if (promoter !== null) { 
			const accessResult = await this.userApi.getPromoterAccess(promoter.id)
			print(accessResult)
			this.setState({access: accessResult})
		}
	}

	getNewPageUrl() {
		if (this.state.organizerName !== null && this.state.organizerName !== '') {
			if (this.props.appDomain === "witheta") {
				return this.state.organizerName + ".witheta.com is your new page url"
			}
			return this.state.organizerName + ".movement.fm is your new page url"
		}
	}

	getProfileView() { 
		return (
		<div>
			<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10}}>
				<GameplanCard
				width="70%"
				>
				 <Form>
				 		<Form.Group>
				 		<FileUploader
				 			title="Upload profile picture"
				 			hint="Maximum size is 2MB"
				 			onChange={(files) => this.setState({uploadedUserImage: files[0]})}
				 			disabled={!this.state.canEditProfile}
				 		/>
				 		</Form.Group>

				 		<ConstrainedFormGroup
				 			label="Username"
				 			value={this.state.username}
				 			type="alphanumeric"
				 			disabled={!this.state.canEditProfile}
				 			onInput={(val) => this.onChange(0, val)}
				 		/>

						  <Form.Group>
						    <Form.Label>Email</Form.Label>
						    <Form.Control value={this.state.email} 
						    onChange={(e) => this.onChange(1, e.target.value)} 
						    disabled={!this.state.canEditProfile} />
						  </Form.Group>
						</Form>
						{this.getProfileButton()}
				</GameplanCard>
			</div>
		</div>
			)
	}


	getPromoterProfileView() { 
		return <div>
			<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10}}>
				<GameplanCard
				width="70%"
				>

				 <div style={{marginBottom: 20}}>
				 <Button onClick={() => Router.push("/o/" + MainUser.getAdminAccess(this.props.user).id)}>View public profile</Button>
				 </div>

				 <Form>
				 		<ConstrainedFormGroup
				 			label="Organizer name"
				 			value={this.state.organizerName}
				 			type="alphanumeric"
				 			disabled={!this.state.canEditPromoter}
				 			onInput={(val) => this.onChange(4, val)}
				 		/>
				 		<p>{this.getNewPageUrl()}</p>

						  <Form.Group>
						    <Form.Label>Instagram</Form.Label>
						    <Form.Control placeholder={this.props.user.promoter_set[0].instagram}
						    value={this.state.instagram} 
						    onChange={(e) => this.onChange(5, e.target.value)} 
						    disabled={!this.state.canEditPromoter} />
						  </Form.Group>

					  <Form.Group>
					    <Form.Label>Bio</Form.Label>
					    <Form.Control as="textarea" 
					    value={this.state.organizerBio} 
					    onChange={(e) => this.onChange(6, e.target.value)}
					    disabled={!this.state.canEditPromoter}
					    />
					    <Form.Text className="text-muted">
					      This bio will appear on the event listing page.
					    </Form.Text>
					  </Form.Group>
				</Form>
				{this.getPromoterButton()}
				</GameplanCard>
			</div>
		</div>
	}

	handleEdit(item) { 
		this.setState({editingAccess: item, showEditModal: true})
	}

	editingDisabled(item) { 
		print(item.username)
		if (this.state.editing === null) { 
			print(this.state.editing)
			return true
		}
		if (this.state.editing === item.id) { 
			print(this.state.editing)
			print(item.id)
			return false
		} 
		return true
	}

	handleHide() { 
		this.setState({editingAccess: null, creatingAccess: false, showEditModal: false})
	}

	onAddAccess() { 
		const newAccess = {
			user : { 
				username: ''
			}, 
			access_level: 'scan'
		}
		this.setState({editingAccess: newAccess, creatingAccess: true, showEditModal: true})
	}

	getUsernameAccessField() { 
		if (this.state.editingAccess === null) { 
			return null
		}

		if (this.state.editingAccess && this.state.creatingAccess == false) {
			return (<h3>{this.state.editingAccess.username}</h3>) 
		} else { 
			print(this.state.editingAccess)
			return <ConstrainedFormGroup
				 		label="Enter username"
				 		value={this.state.editingAccess.username}
				 		type="alphanumeric"
				 		onInput={(val) => this.onChange(3, val)}
				 	/>
		}
	}

	handleAccessResult(result, successMessage) { 
		print(result)
		if (result.code === -1) { 
			this.modalManager.showError(this, result.error.detail)
			return
		}

		if (result === null) { 
			this.modalManager.showError(this, "Sorry, something went wrong")
			return
		} 

		this.modalManager.showSuccess(this, successMessage)
	}

	async handleDeleteAccess() { 
		const result = await this.userApi.deletePromoterAccess(this.state.editingAccess.id)
		this.handleAccessResult(result, "Access successfully deleted")
	}

	async submitAccessChange() { 
		var result = null
		const editingAccess = this.state.editingAccess
		if (!this.state.creatingAccess) { 
			result = await this.userApi.updatePromoterAccess(editingAccess.id, editingAccess.access_level)
			this.handleAccessResult(result, "Access succesfully updated")
		} else { 
			result = await this.userApi.createPromoterAccess(editingAccess.username, editingAccess.access_level)
			this.handleAccessResult(result, "Access succesfully created")
		}
	}


	getUserStories() { 
		if (this.props.promoter !== undefined){ 
			return (<NoSSR> 
			<ArticleSection style={{marginRight: 20, marginLeft: 20, marginBottom: 20}}
					noDivider
					title="Stories" articles={this.props.promoter.stories}
					onClicked={(id) => Router.push("/story/" + id)}/>
			</NoSSR>)
		}
	}

	handleSystemModalHide(success){
		print("Handling closing")
		print(success)
		if (!success) { 
			this.modalManager.hideModal(this)
		} else { 
			this.setState({showEditModal: false})
			window.location.reload(true)
		}
	}



	getTitle() { 
		if (this.state.public) { 
			return <div>
			<h3 style={{color: 'white'}}>{this.props.promoter.username}</h3>
			</div>


		} else {
			return <div>
			{this.props.user.promoter_set.length > 0 && <h3 style={{color: 'white', paddingBottom: 20}}>Organizer</h3> }
			</div>
		}
	}

	getBio() { 
		if (this.state.public) { 
			return <div style={styles.centeredDiv}>
				<Container style={{textAlign: 'center', marginBottom: 20}}>
					<p style={{color: 'white'}}>{this.props.promoter.about}</p>
					<a href={this.props.promoter.instagram}>{this.props.promoter.instagram}</a>
				</Container>
			</div>
		} else { 
			return null
		}
	}


	getTabBody() { 
		if (!this.state.public) { 
			//TODO: Make these into components
			return <Tabs className="justify-content-center" defaultActiveKey="profile" id="uncontrolled-tab-example"> 
			<Tab eventKey="profile" title="Profile">
			  {this.getProfileView()}
			  </Tab>

			{MainUser.hasAdminAccess(this.props.user) && <Tab eventKey='promoter' title="Organizer">
				{this.getPromoterProfileView()}
			</Tab>
			}

			 {MainUser.hasAdminAccess(this.props.user)  && <Tab eventKey="accesss" title="Access">
			 
			 	<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
			 	<GameplanCard width="100%" style={{textAlign: 'center'}}> 
			 	<Table striped bordered hover>
				  <thead>
				    <tr>
				      <th>Username</th>
				      <th>Access Level</th>
				      <th>Edit</th>
				    </tr>
				  </thead>
				  <tbody>
				    {this.state.access.map((item, index) => 
			 		<tr>
			 			<td>
			 			{item.username}
			 			</td>

			 			<td>
			 			 <Form.Control as="select" onChange={(e)=>this.props.onChange(2, e.target.value)}
			 			 disabled>
							      <option>{item.access_level}</option>
						</Form.Control>
			 			</td>

			 			<td>
			 				<Button variant="primary" onClick={()=> this.handleEdit(item)}>Edit</Button>
			 			</td>
			 		</tr>
			 		)}
				  </tbody>
				</Table>
					<Button variant="primary" onClick={()=>this.onAddAccess()}>Add</Button>
			 	</GameplanCard>
			 	</div>
			  </Tab>}

			  <Tab eventKey="contact" title="Setting">
			  	<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
				  	<GameplanCard width="70%">
				  	<div style={{display: 'flex', justifyContent: 'center'}}>
				  		<div>
							<Button variant="primary" style={{marginRight:10}} onClick={() => this.logout()}>Logout</Button>
						</div>
						<div>
							{this.props.user.is_staff === true && <Button variant="primary" style={{marginRight:10}}>Environment</Button>}
						</div>
					</div>
					</GameplanCard>
				</div>
			  </Tab>
			 </Tabs>
			} else { 	
				return <Tabs className="justify-content-center" defaultActiveKey="upcoming_events" id="uncontrolled-tab-example"> 
					<Tab eventKey="past_events" title="Past Events">
					<Container style={{marginTop: 20}}>
						{this.props.promoter.past_events !== undefined && this.props.promoter.past_events.map((item, index) => 
							<EventCell
								style={{maxWidth: '80%', marginBottom: 20}}
								event={item}
							/>
							)}
					</Container>
					</Tab>

					<Tab eventKey="upcoming_events" title="Upcoming Events">
					<Container style={{marginTop: 20}}>
					{this.props.promoter.upcoming_events !== undefined && this.props.promoter.upcoming_events.slice(0, 6).map((item, index) => 
							<EventCell
								style={{maxWidth: '80%'}}
								event={item}
							/>
							)}
					</Container>
					</Tab>
				</Tabs>
			}
	}

	getImage() { 
		if (this.state.public) { 
			return getPossibleProfileImage(this.props.promoter.image)
		} else { 
			return getUserImage(this.props.user)
		}
	}


	render() {

		if (this.props.error === true) { 
			return <ErrorView/>
		}

		print(this.props.user)
		if (this.props.user == null && !this.state.public) { 
			return <div>User does not exist</div>
		}

		return (
			<Layout
			fluid
			style={{paddingRight:0, paddingLeft: 0, margin: 0}}>
			<div style={{backgroundColor: 'black', marginBottom: 20}}>
				<div style={{textAlign: 'center', paddingTop:20, marginBottom: 40}}>
					<div style={{borderWidth: 10, borderColor: 'white'}}>
						<Image
							width={120}
						    height={120}
						    className="mr-3"
						    src={this.getImage()}
						    alt="Generic placeholder"
						    style={{marginBottom: 15}}
						    roundedCircle 
						    />
					</div>

				  	{this.getTitle()}
				</div>

				{this.getBio()}
			</div>
				{this.getUserStories()}

				{this.getTabBody()}


			<SystemModal
				show={this.state.system.show}
				error={this.state.system.error}
				loading={this.state.system.loading}
				message={this.state.system.message}
				onHide={(success) => this.handleSystemModalHide(success)}
			/>

			<Modal
			show={this.state.showEditModal}
			onHide={() => this.handleHide()}>
			<Modal.Header closeButton>
				<h2>Edit Access</h2>
			</Modal.Header>
			<Modal.Body>
				<div>
				{this.getUsernameAccessField()}
				</div>

				<Form.Control as="select" onChange={(e)=>this.onChange(2, e.target.value)}>
								  {!this.state.creatingAccess && <option>--</option>}
							      <option>scan</option>
							      <option>admin</option>
						</Form.Control>

				<div style={{marginTop: 20, display: 'flex', flexDirection: 'row'}}>
					<Button variant="outline-primary" onClick={()=> this.submitAccessChange()}>Submit</Button>
					{!this.state.creatingAccess && <Button style={{alignSelf: 'flex-end', marginLeft: 20}} 
					variant="danger" onClick={()=> this.handleDeleteAccess()}>Delete</Button>}
				</div>

			</Modal.Body>
			</Modal>
			</Layout>
			)
	}
}

const styles = { 
	centeredDiv: {
		display: 'flex', 
		alignItems: 'center',
		justifyContent: 'center'
	}
}

export default connect(state => state)(Profile)